import React from 'react';

import { ChildrenProps } from '../../../utils';
import { BannerType } from '../Banner/Banner';
import { Banner } from '../index';

type Props = ChildrenProps;

const BannerReminder = ({ children }: Props) => {
  return (
    <>
      <Banner type={BannerType.REMINDER}>{children}</Banner>
    </>
  );
};

export default BannerReminder;
